<!-- ========== App Menu ========== -->
<div class="app-menu navbar-menu">
  <!-- LOGO -->
  <div class="navbar-brand-box">
      <!-- Dark Logo-->
      <a routerLink="/" class="logo logo-dark">
          <span class="logo-sm ms-n3 mt-1">
              <img src="assets/brandimages/{{vendoruniquekey}}/logo-sm.png" alt="" height="40">
          </span>
          <span class="logo-lg ms-n1">
              <img src="assets/brandimages/{{vendoruniquekey}}/logo-light.png" alt="" width="120">
          </span>
      </a>
      <!-- Light Logo-->
      <a routerLink="/" class="logo logo-light">
          <span class="logo-sm ms-n3 mt-1">
              <img src="assets/brandimages/{{vendoruniquekey}}/logo-sm.png" alt="" height="40">
          </span>
          <span class="logo-lg ms-n1">
              <img src="assets/brandimages/{{vendoruniquekey}}/logo-light.png" alt="" width="120">
          </span>
      </a>
      <button type="button" class="btn btn-sm p-0 fs-24 header-item float-end btn-vertical-sm-hover" id="vertical-hover" (click)="toggleMobileMenu($event)">
          <i class="mdi mdi-record-circle-outline"></i>
      </button>
  </div>

  <div id="scrollbar">
      <div class="container-fluid">

          <div id="two-column-menu">
          </div>
          <ngx-simplebar class="sidebar-menu-scroll" style="max-height: calc(100vh - 70px)">
          <ul class="metismenu list-unstyled navbar-nav" id="navbar-nav">
            @for(item of menuItems; track $index){
              @if(item.accessibility) {
              <li class="nav-item">
                <a [routerLink]="item.route" class="side-nav-link-ref nav-link menu-link">
                  @if(item.icon){<i class="{{ item.icon }} icon nav-icon" class=""></i>}
                  @if(item.count && (userData.role!.id != this.roles.Member || item.key_label == 'inbox')){
                    <span class="fw-normal badge rounded-pill bg-danger">{{item.count}}</span>
                  }
                  <span class="menulabel"> {{ item.label  }}</span>
                </a>
              </li>
            }
            }
          </ul>
          </ngx-simplebar>
      </div>
      <!-- Sidebar -->
  </div>
  <div class="sidebar-background"></div>
</div>
<!-- Left Sidebar End -->
<!-- Vertical Overlay-->
<div class="vertical-overlay" (click)="SidebarHide()"></div>

